import { useEffect, useState } from "react";
import { ProductViewModel } from "../../../../viewmodels/setup/myProducts/ProductViewModel";

import { useLocation } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../../../store/actions/index";

import {
  classNames,
  getLastItem,
  isFeatureFlag,
  withRouter,
} from "../../../../shared/utility";

import ProductDetailsForm from "../../../../components/forms/setup/product/ProductDetailsForm";
import ProductSpecSheet from "../../../../components/forms/setup/product/pdf/ProductSpecSheet";
import ProductProcessStatusAssigned from "../../processStatus/ProductProcessStatusAssigned";
import ProductRnd from "../productRnd/ProductRnd";
import EmptyModal from "../../../../components/modals/EmptyModal";
import EmbeddedAuditHistory from "../../../../components/audit/EmbeddedAuditHistory";
import { getAuditApiEntityType } from "../../../../components/audit/auditEntityConfig";
import FormSectionLoadingSkeleton from "../../../../components/operational/FormSectionLoadingSkeleton";
import ProductPriceRules from "../../../../components/forms/setup/product/ProductPriceRules";

const getTabs = () => {
  const baseTabs = [
    { name: "Product Details", href: "#" },
    { name: "Specs Sheet", href: "#" },
    { name: "Price Rules", href: "#" },
  ];

  if (isFeatureFlag("isQa")) {
    baseTabs.push({ name: "Process Status", href: "#" });
  }
  baseTabs.push({ name: "Product R&D", href: "#" });
  baseTabs.push({ name: "Analytics", href: "#" });
  baseTabs.push({ name: "Audit History", href: "#" });

  return baseTabs;
};

function ProductScreen(props) {
  const { addSnackbar, logout } = props;

  const [currentTab, setCurrentTab] = useState(0);
  const tabs = getTabs();

  const { pathname } = useLocation();
  const productId = getLastItem(pathname);

  const {
    allergensOptions,
    getAllergensForDropdown,
    getProduct,
    loading,
    product,
    updateProduct,
    unitOfMeasureOptions,
    getUnitOfMeasuresForDropdown,
    getProductTypes,
    productTypeOptions,
    emptyModal,
    setEmptyModelOpen,
    updatePriceRulePrice,
  } = ProductViewModel(logout, productId, addSnackbar);

  const onStartDependencides = async function () {
    getAllergensForDropdown();
    getUnitOfMeasuresForDropdown();
    getProduct();
    getProductTypes();
  };

  useEffect(() => {
    onStartDependencides();
  }, []);

  const renderComponent = (index) => {
    const tabName = tabs[index]?.name;

    switch (tabName) {
      case "Product Details":
        return (
          <div
            key="product-details"
            className="rounded-[18px] border border-[#E2E8F0] bg-white p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:p-6"
          >
            {loading ? (
              <FormSectionLoadingSkeleton rows={4} />
            ) : (
              <ProductDetailsForm
                allergensOptions={allergensOptions}
                product={product}
                actionCall={updateProduct}
                isEdit={true}
                unitOfMeasureOptions={unitOfMeasureOptions}
                productTypeOptions={productTypeOptions}
              />
            )}
          </div>
        );

      case "Specs Sheet":
        return (
          <div
            key="specs-sheet"
            className="rounded-[18px] border border-[#E2E8F0] bg-white p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:p-6"
          >
            <ProductSpecSheet product={product} />
          </div>
        );

      case "Price Rules":
        return (
          <ProductPriceRules product={product} onSave={updatePriceRulePrice} />
        );

      case "Process Status":
        return (
          <div key="process-status">
            <ProductProcessStatusAssigned
              productId={productId}
              logout={logout}
              addSnackbar={addSnackbar}
            />
          </div>
        );

      case "Product R&D":
        return (
          <div
            key="product-rnd"
            className="rounded-[18px] border border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]"
          >
            {loading || !product ? (
              <div className="p-6">
                <FormSectionLoadingSkeleton rows={5} />
              </div>
            ) : (
              <ProductRnd
                product={product}
                logout={logout}
                addSnackbar={addSnackbar}
              />
            )}
          </div>
        );

      case "Analytics":
        return (
          <div
            key="analytics"
            className="rounded-[18px] border border-[#E2E8F0] bg-white p-8 text-center shadow-[0_1px_2px_rgba(15,23,42,0.04)]"
          >
            <p className="text-sm font-semibold uppercase tracking-wide text-[#64748B]/70">
              Coming Soon
            </p>
            <h2 className="mt-2 text-xl font-bold text-[#0F172A]">
              Product analytics
            </h2>
            <p className="mt-2 text-sm text-[#64748B]">
              Performance, production, and sales analytics can live here later.
            </p>
          </div>
        );

      case "Audit History":
        return (
          <div
            key="audit-history"
            className="rounded-[18px] border border-[#E2E8F0] bg-white p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:p-6"
          >
            <h2 className="mb-4 text-sm font-semibold text-[#0F172A]">
              Change history
            </h2>
            <EmbeddedAuditHistory
              entityId={productId}
              entityType={getAuditApiEntityType("product")}
              logout={logout}
            />
          </div>
        );

      default:
        return (
          <div
            key="error"
            className="rounded-2xl border border-[#FECACA] bg-[#FEF2F2] p-5 text-sm text-[#DC2626]"
          >
            Could not load page, please try again.
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F8FB] px-4 py-5 sm:px-6 lg:px-8">
      <main className="mx-auto max-w-7xl space-y-6">
        <section className="rounded-[18px] border border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)] hide-for-print">
          <div className="border-b border-[#E2E8F0] px-6 py-5">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#64748B]">
              Product Setup
            </p>
            <h1 className="mt-2 text-[1.65rem] font-semibold tracking-tight text-[#0F172A] sm:text-3xl">
              {loading ? "Loading product..." : (product?.name_en ?? "Product")}
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-[#64748B]">
              Edit product details, generate specification sheets, and review
              product-level information.
            </p>
          </div>

          <div className="p-4 sm:p-5">
            <div className="sm:hidden">
              <label htmlFor="tabs" className="sr-only">
                Select a tab
              </label>
              <select
                id="tabs"
                name="tabs"
                className="block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2 text-sm shadow-sm"
                value={currentTab}
                onChange={(event) => setCurrentTab(Number(event.target.value))}
              >
                {tabs.map((tab, index) => (
                  <option key={tab.name} value={index}>
                    {tab.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav
                className="flex rounded-xl border border-[#E2E8F0] bg-[#F6F8FB] p-1"
                aria-label="Tabs"
              >
                {tabs.map((tab, index) => (
                  <button
                    key={tab.name}
                    type="button"
                    className={classNames(
                      index === currentTab
                        ? "bg-white text-[#2563EB] shadow-sm ring-1 ring-[#E2E8F0]"
                        : "text-[#64748B] hover:bg-white hover:text-[#0F172A]",
                      "flex-1 rounded-lg px-4 py-2.5 text-sm font-semibold transition",
                    )}
                    aria-current={index === currentTab ? "page" : undefined}
                    onClick={() => setCurrentTab(index)}
                  >
                    {tab.name}
                  </button>
                ))}
              </nav>
            </div>
          </div>
        </section>

        <section>
          {tabs.map((item, index) =>
            index === currentTab ? renderComponent(index) : null,
          )}
        </section>
      </main>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductScreen),
);
